/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Dangerzonedescription_Leave3Inputs */

const zh_organizationsettings_dangerzonedescription_leave3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Leave3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开组织后，你将失去对其所有资源的访问权限。`)
};

const en_organizationsettings_dangerzonedescription_leave3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Leave3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you leave an organization, you will lose access to all its resources.`)
};

const es_organizationsettings_dangerzonedescription_leave3 = /** @type {(inputs: Organizationsettings_Dangerzonedescription_Leave3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez que abandones una organización, perderás acceso a todos sus recursos.`)
};

/**
* | output |
* | --- |
* | "Once you leave an organization, you will lose access to all its resources." |
*
* @param {Organizationsettings_Dangerzonedescription_Leave3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_dangerzonedescription_leave3 = /** @type {((inputs?: Organizationsettings_Dangerzonedescription_Leave3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Dangerzonedescription_Leave3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_dangerzonedescription_leave3(inputs)
	if (locale === "en") return en_organizationsettings_dangerzonedescription_leave3(inputs)
	return es_organizationsettings_dangerzonedescription_leave3(inputs)
});
export { organizationsettings_dangerzonedescription_leave3 as "organizationSettings_dangerZoneDescription_leave" }